import { Injectable, OnInit } from '@angular/core';
import { Subject ,  BehaviorSubject ,  Subscription } from 'rxjs';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { GlobalsService } from '../../../../../core/services/globals.service';
import { CustomerContactChannelType } from '../../../../../core/interfaces/customerContactChannelType';
import { AutoUnsubscribe } from '../../../../../core/decorators/auto-unsubscribe';
import { ValidateFiscalCodeService } from './servicios/validate-fiscal-code.service';
import { CustomerContactPurposeType } from '../../../../../core/interfaces/CustomerContactPurposeType';
import { Iban } from '../../../../../core/interfaces/iban';
import { CanBeDeleteService } from './servicios/can-be-delete.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { IsDeactivatedService } from './servicios/is-deactivated.service';
import { environment } from '../../../../../../environments/environment';
import { GeneralGestionTercerosService } from './servicios/general-gestion-tercerosService.Service';
import { DataSaveService } from '../../../../../core/services/data-save.service';
import { Paginacion } from '../../../../../core/interfaces/paginacion';
import { Categories } from '../../../../../core/interfaces/categories';
import { map } from 'rxjs/operators';
import { ButtonsActivateService } from '../../../../../core/services/buttons-activate.service';
import { HttpClient } from '@angular/common/http';
import { IConfirmConfig } from '../../../../../shared/confirm/confirm.config';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmService } from '../../../../../shared/confirm/confirm.service';
import {postalCodeValidator} from '../../../../../core/validators/postalCode.validator';
import {paymentCodeValidator} from '../../../../../core/validators/paymentCode.validator';
import {defaultValueValidator} from '../../../../../core/validators/default-value.validator';

@Injectable()
@AutoUnsubscribe()
export class GestionTercerosService implements OnInit {

    private _currentStep;
    public actualCustomerCode = new BehaviorSubject<string>('');

    defaultCustomerType: any;
    defaultCustomerCategory: object;
    categories: Categories[];
    objetoPaginacion: Paginacion;
    pais: string;
    public allDataCustomer = new BehaviorSubject<any>({});
    isValidEntryFiscalCode = true;
    isDuplicateFiscalCode = false;
    datosCustomerGestionForm: any;
    busquedaPor: number;
    isValidIban = false;
    public newCustomer: boolean;
    public moveOn = new Subject<boolean>();
    public moveIn = new Subject<boolean>();
    public creadoCustomer = new Subject<boolean>();
    error: string;
    code: string;
    formMode: boolean = false;
    modoEdicion: boolean;
    camposIbanCompletos = false;
    customerForm: FormGroup;
    items: FormArray;
    dataCustomer: any;
    fechaActual: any;
    CustomerContactPurposeTypeList: CustomerContactPurposeType[] = [];
    subs1: Subscription;
    puedeBorrarse: boolean;
    estaDesactivado: boolean;
    sePuedeDesactivar: boolean;
    bank5: Subscription;
    auxCustomerCode: string;
    _datosCustomer: any;
    _recepcionCustmer: any;

    customerFormSubscription: Subscription;
    CustomerContactChannelTypeList: CustomerContactChannelType[] = [];
    Iban: Iban;
    paisService: string;
    botonGuardar: boolean;
    botonReactivar: boolean;
    showBoxResults = false;
    boxResults = false;
    dataBoxResults: any[] = [];
    customer: any;
    pantalla: string;
    deshabilitarCampos: boolean;
    escogidoBuscador: string;
    fiscalCodeOrigen: string;
    dataCustomerSave: any;
    public finishUpdate = new Subject<boolean>();
    emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    statusBA: boolean;
    revocaDate: string;
    canUpdateAddress = true;

    constructor(
        private _dataSaveService: DataSaveService,
        private _generalGestionTercerosService: GeneralGestionTercerosService,
        private _isDeactivatedService: IsDeactivatedService,
        private _authService: AuthService,
        private _canBeDeleteService: CanBeDeleteService,
        private _validateFiscalCodeService: ValidateFiscalCodeService,
        private _globals: GlobalsService,
        private _translateService: TranslateService,
        private _confirm: ConfirmService,
        private _buttonsActivateService: ButtonsActivateService,
        private _http: HttpClient
    ) {
        this.fechaActual = this._globals.getDateFormatToday();
        this.puedeBorrarse = false;
    }

    observerFinishUpdate() {
        return this.finishUpdate.asObservable();
    }

    setUpdate() {
        this.finishUpdate.next(true);
    }

    ngOnInit() {
        this.fiscalCodeOrigen = '';
        this.pais = this._authService.getDataPais();
    }

    get f() { return this.customerForm.controls; }

    setValidatorRequired(control, campo, requerido) {
        this.customerForm.get(control).get(campo).setValidators(requerido);
        this.customerForm.get(control).get(campo).updateValueAndValidity();
    }

    saveDataForm(cargarVista) {
        this.checkSelfEmployed();
        const datosForm = this.customerForm.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormulario(cargarVista, auxForm);
    }

    crearFormularioCustomer(cargarVista, customerCode, InternalAditionalRole) {
        this.formMode = this._authService.getUserRole();

        if (!this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }

        this.paisService = this._authService.getDataPais();

        this.CustomerContactChannelTypeList =
            [
                {
                    ChannelTypeCode: 'CP',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'FX',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'MA',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'RS',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'SS',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'TE',
                    CustomerCode: customerCode,
                    IsActivated: false
                },
                {
                    ChannelTypeCode: 'WA',
                    CustomerCode: customerCode,
                    IsActivated: false
                }
            ];

        this.CustomerContactPurposeTypeList = [
            {
                CustomerCode: customerCode,
                EndDate: this._globals.getDateFormatForServer(this.fechaActual),
                PurposeTypeCode: 'CA'
            }, {
                CustomerCode: customerCode,
                EndDate: this._globals.getDateFormatForServer(this.fechaActual),
                PurposeTypeCode: 'CC'
            }, {
                CustomerCode: customerCode,
                EndDate: this._globals.getDateFormatForServer(this.fechaActual),
                PurposeTypeCode: 'ES'
            }, {
                CustomerCode: customerCode,
                EndDate: this._globals.getDateFormatForServer(this.fechaActual),
                PurposeTypeCode: 'OT'
            }, {
                CustomerCode: customerCode,
                EndDate: this._globals.getDateFormatForServer(this.fechaActual),
                PurposeTypeCode: 'PE'
            }
        ];

        this.Iban = {
            AccountNumber: '',
            AccountType: '',
            BankCode: '',
            BranchCode: '',
            CheckDigit: '',
            Country: this.paisService.toUpperCase(),
            IdentificationNumber: '',
            IsValid: false,
            NationalCheckDigit: '',
            OwnerAccountType: '',
            Value: ''
        };
        const customerType = '**';
        const customerCategory = { CUSTOMERCATEGORY: '**', Description: 'No disponible' };

        const DiscountPR = { DiscountCode: '**', Description: '**' };
        const pais = {
            CountryCode: this.paisService.toUpperCase(),
            Name: this.paisService.toUpperCase() === 'PT' ? 'PORTUGAL' : 'ESPAÑA'
        };
        this.customerForm = new FormGroup({
            datosPrincipales: new FormGroup({
                CustomerCode: new FormControl(customerCode, { validators: [Validators.required, Validators.minLength(6)], updateOn: 'blur' }),
                IdentificationType: new FormControl({ value: '02', disabled: this.deshabilitarCampos }),
                fiscalCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }), //[Validators.required]
                tratamiento: new FormControl({ value: 1, disabled: this.deshabilitarCampos }),
                CustomerName: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.required]),
                customerSurnameFirst: new FormControl({ value: '', disabled: this.deshabilitarCampos }),  //  [Validators.required]
                customerSurnameSecond: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                customerSelfEmployed: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                customerBussinesName: new FormControl({ value: '', disabled: this.deshabilitarCampos })
            }),
            datosIdentificacion: new FormGroup({
                VATRegime: new FormControl('GE'),
                InternalAditionalRole: new FormControl(InternalAditionalRole), // 0 | 2 | 3 radio button origen
                customerType: new FormControl({ value: customerType, disabled: cargarVista == 'voClientes' }), //[C, A, B, S] , [Validators.required]
                customerCategory: new FormControl({ value: customerCategory, disabled: this.deshabilitarCampos }, [Validators.required]),
                address: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.required]),
                postalCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [postalCodeValidator(this._authService.getDataPais(), pais)]),
                province: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                city: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                pais: new FormControl({ value: pais, disabled: this.deshabilitarCampos }),
                NationalityCode: new FormControl({ value: pais.CountryCode, disabled: this.deshabilitarCampos }),
                IntraCommunity: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                fechaNacimiento: new FormControl({ value: null, disabled: this.deshabilitarCampos }), //  /Date(1557352800000)/
                notas: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                arcadCode: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
                sfCustomerId: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            }),
            contactInformation: new FormGroup({
                telephoneHome: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                telephoneOffice: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.pattern(this.emailRegex)),//, [Validators.email]
                fax: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                privacy: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                customerContactChannelTypeList: new FormControl({ value: this.CustomerContactChannelTypeList, disabled: this.deshabilitarCampos }),
                dateSignatureConsentDocument: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
                customerContactPurposeTypeList: new FormControl({ value: this.CustomerContactPurposeTypeList, disabled: this.deshabilitarCampos }),
                thirdAssignment: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                allowContactBrand: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                allowProfilingBrand: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                consentDocumentId: new FormControl(null),
            }),
            gestion: new FormGroup({
                ExemptionVatCode: new FormControl({ value: '**', disabled: this.deshabilitarCampos }),
                DiscountPR: new FormControl({ value: DiscountPR, disabled: this.deshabilitarCampos }, [Validators.required]),
                PriceMO: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
                SpecialDiscount: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
                DiscountMO: new FormControl({ value: '**', disabled: this.deshabilitarCampos }),
                AccountingCode: new FormControl({ value: customerCode, disabled: this.deshabilitarCampos }, [Validators.required]),// cuando es nuevo el accountingCode es igual que el customerCode
                MandateReference: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
                MandateSigningDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }), // Fecha de firma
                CreditLimit: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
                CreditLocked: new FormControl({ value: false, disabled: this.deshabilitarCampos }),
                CreditSpent: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
                PaymentCode: new FormControl({ value: '***', disabled: this.deshabilitarCampos }, [paymentCodeValidator()]),
                PaymentDay1: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
                PaymentDay2: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
                AmountPendingCashPayments: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
                Iban: new FormGroup({
                    AccountNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    AccountType: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    BankCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    BranchCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    CheckDigit: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    Country: new FormControl({ value: 'ES', disabled: this.deshabilitarCampos }),
                    IdentificationNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    IsValid: new FormControl(false),
                    NationalCheckDigit: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    OwnerAccountType: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
                    Value: new FormControl(''),
                }),
            }),
            centres: new FormGroup({
                AdminCenterEReceptorId: new FormControl(0),
                AdminCenterEPayerId: new FormControl(0),
                AdminCenterEFiscalId: new FormControl(0),
                AdminCenterEBuyerId: new FormControl(0)
            })
        });
        this.isValidIban = false;
        this.camposIbanCompletos = true;
        this.deshabilitandoCampos();
        if (cargarVista == 'voClientes') {
            this.setValidatorRequired('datosIdentificacion', 'customerType', null);
            this.setValidatorRequired('datosIdentificacion', 'customerCategory', Validators.required);
        } else {
            this.setValidatorRequired('datosIdentificacion', 'customerType', [Validators.required, defaultValueValidator('**')]);
        }

        this.customerForm.get('datosPrincipales').get('CustomerCode').valueChanges.subscribe(val => {
            const nuevoAccountingCode = val;
            if (val !== '' && isNaN(nuevoAccountingCode)) {
                // mostrar confirm
                this._translateService.get(['labels.aceptar', 'gestion_terceros.popup.alphanumeric_code']).subscribe((res) => {
                    const confirmConfig: IConfirmConfig = {
                        title: ' ',
                        message: res['gestion_terceros.popup.alphanumeric_code'],
                        textButtonAccept: res['labels.aceptar'],
                        onButtonAccept: () => {
                        }
                    };
                    this._confirm.confirmConfig = confirmConfig;
                    this._confirm.showConfirm(true);
                });

            } else {
                if (val !== '') {
                    this.customerForm.get('gestion').get('AccountingCode').setValue(nuevoAccountingCode, { emitEvent: false });
                }
            }
        });
        this.cambiosDesplegablePais();
        if (!this.customerFormSubscription) {
            this.customerForm.valueChanges.subscribe((val) => {
                this.saveDataForm(cargarVista);
            });
        }

        this.saveDataForm(cargarVista);
        this.creadoCustomer.next(true);
    }

    cambiosDesplegablePais(){
        this.customerForm.get('datosIdentificacion').get('pais').valueChanges.subscribe(val => {
            this.customerForm.get('datosIdentificacion').get('postalCode').setValidators([postalCodeValidator(this._authService.getDataPais(), val)]);
            this.customerForm.get('datosIdentificacion').get('postalCode').updateValueAndValidity();
        });
    }

    crearFormularioCustomerWithData(cargarVista, dataCustomer, categorias) {
        this.categories = categorias;
        if (dataCustomer.FiscalCode) {
            this.fiscalCodeOrigen = dataCustomer.FiscalCode;
        }

        this.paisService = this._authService.getDataPais();

        this.comprobarDelete();
        this.comprobarIsDeactivated(dataCustomer);
        this.statusBA = this.testDeleted(dataCustomer.Status);

        if (!this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }
        if ((dataCustomer.CheckDigit && dataCustomer.BankCode && dataCustomer.BranchCode && dataCustomer.NationalCheckDigit && dataCustomer.AccountNumber) ||
        (dataCustomer.Iban.CheckDigit && dataCustomer.Iban.BankCode && dataCustomer.Iban.BranchCode && dataCustomer.Iban.NationalCheckDigit && dataCustomer.Iban.AccountNumber)) {
            this.camposIbanCompletos = true;
            this.isValidIban = dataCustomer.IsValid ? dataCustomer.IsValid : dataCustomer.Iban.IsValid;
        } else {
            this.camposIbanCompletos = false;
            this.isValidIban = true;
        }
        this.CustomerContactChannelTypeList =
            [
                {
                    ChannelTypeCode: 'CP',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'FX',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'MA',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'RS',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'SS',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'TE',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                },
                {
                    ChannelTypeCode: 'WA',
                    CustomerCode: this.auxCustomerCode,
                    IsActivated: true
                }
            ];
        let auxIbanCountry = '';
        if (dataCustomer.Iban && dataCustomer.Iban.Country && dataCustomer.Iban.Country.CountryCode) {
            auxIbanCountry = dataCustomer.Iban.Country.CountryCode;
        } else {
            auxIbanCountry = 'ES';
        }
        let auxCheckDigit = '';
        let auxBankCode = '';
        let auxBranchCode = '';
        let auxNationalCheckDigit = '';
        let auxAccountNumber = '';
        const auxCuenta = dataCustomer.Iban.Value;
        if (auxCuenta) {
            auxCheckDigit = auxCuenta.substr(2, 2);
            auxBankCode = auxCuenta.substr(4, 4);
            auxBranchCode = auxCuenta.substr(8, 4);
            auxNationalCheckDigit = auxCuenta.substr(12, 2);
            auxAccountNumber = auxCuenta.substr(14, 10);
        }

        let comboCustomerCategorias = [];
        if (this.pais === 'fr') {
            comboCustomerCategorias = [
                { value: '**', text: 'Seleccionar' },
                { value: 'C', text: 'Client' },
                { value: 'S', text: 'Fournisseur' },
                { value: 'B', text: 'Client/Fournisseur' },
                { value: 'A', text: 'Client/Assurance' },
                { value: 'R', text: 'Client/Sucursal' },
                { value: 'L', text: 'Fournisseur/Sucursal' },
                { value: 'M', text: 'Client/Fournisseur/Sucursal' }
            ];
        } else if (this.pais === 'pt'){
            comboCustomerCategorias = [
                { value: '**', text: 'Selecionar' },
                { value: 'C', text: 'Cliente' },
                { value: 'S', text: 'Fornecedor' },
                { value: 'B', text: 'Cliente/Fornecedor' },
                { value: 'A', text: 'Cliente/Seguradora' }
            ];
        }else {
            comboCustomerCategorias = [
                { value: '**', text: 'Seleccionar' },
                { value: 'C', text: 'Cliente' },
                { value: 'S', text: 'Proveedor' },
                { value: 'B', text: 'Cliente/Proveedor' },
                { value: 'A', text: 'Cliente/Aseguradora' }
            ];
        }
        // this.defaultCustomerType = { value: '**', text: 'Seleccionar' };
        this.defaultCustomerType = '**';

        if (dataCustomer.CustomerType && dataCustomer.CustomerType !== '**' && comboCustomerCategorias) {
            comboCustomerCategorias.forEach((item) => {
                if (item.value === dataCustomer.CustomerType) {
                    this.defaultCustomerType = item.value;
                }
            });
        }
        this.defaultCustomerCategory = { CUSTOMERCATEGORY: '**', Description: 'No disponible' };

        if (dataCustomer.ClientCustomerRegistry && dataCustomer.ClientCustomerRegistry.CUSTOMERCATEGORY && this.categories) {
            this.categories.forEach((item) => {
                if (item.CUSTOMERCATEGORY === dataCustomer.ClientCustomerRegistry.CUSTOMERCATEGORY) {
                    this.defaultCustomerCategory = item;
                }
            });
        }
        this.customerForm = new FormGroup({

            datosPrincipales: new FormGroup({
                CustomerCode: new FormControl({ value: dataCustomer.CustomerCode, disabled: true }),
                IdentificationType: new FormControl({ value: dataCustomer.IdentificationType, disabled: this.deshabilitarCampos }),
                fiscalCode: new FormControl({ value: dataCustomer.FiscalCode, disabled: this.deshabilitarCampos }), //, [Validators.required]
                tratamiento: new FormControl({ value: dataCustomer.Courtesy ? dataCustomer.Courtesy : 1, disabled: this.deshabilitarCampos }),
                CustomerName: new FormControl({ value: dataCustomer.Name2, disabled: this.deshabilitarCampos }, [Validators.required]),
                customerSurnameFirst: new FormControl({ value: dataCustomer.LastName1 ? dataCustomer.LastName1 : '', disabled: this.deshabilitarCampos }),
                customerSurnameSecond: new FormControl({ value: dataCustomer.LastName2 ? dataCustomer.LastName2 : '', disabled: this.deshabilitarCampos }),
                customerSelfEmployed: new FormControl({ value: dataCustomer.SelfEmployed ? dataCustomer.SelfEmployed : false, disabled: this.deshabilitarCampos }),
                customerBussinesName: new FormControl({ value: dataCustomer.BussinesName ? dataCustomer.BussinesName : '', disabled: this.deshabilitarCampos })
            }),

            datosIdentificacion: new FormGroup({
                VATRegime: new FormControl(dataCustomer.VATRegime ? dataCustomer.VATRegime : 'GE'),
                InternalAditionalRole: new FormControl(dataCustomer.InternalAditionalRole ? dataCustomer.InternalAditionalRole.toString() : '0'), // 0 |2 radio button InternalAditionalRole
                customerType: new FormControl(this.defaultCustomerType, [Validators.required, defaultValueValidator('**')]), //  [C, A, B, S]
                customerCategory: new FormControl({ value: this.defaultCustomerCategory, disabled: this.deshabilitarCampos }, [Validators.required]), // Esto es el selector de categoria Cliente
                address: new FormControl({ value: dataCustomer.Address, disabled: this.deshabilitarCampos || !this.canUpdateAddress }, [Validators.required]),
                postalCode: new FormControl({ value: dataCustomer.PostalCode, disabled: this.deshabilitarCampos || !this.canUpdateAddress }, [postalCodeValidator(this._authService.getDataPais(), dataCustomer.Country)]),
                province: new FormControl({ value: dataCustomer.Province, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                city: new FormControl({ value: dataCustomer.City, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                pais: new FormControl({ value: dataCustomer.Country, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                NationalityCode: new FormControl({ value: dataCustomer.NationalityCode ? dataCustomer.NationalityCode : dataCustomer.Country.CountryCode, disabled: this.deshabilitarCampos }),
                IntraCommunity: new FormControl({ value: dataCustomer.IntraCommunity === true ? true : false, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                fechaNacimiento: new FormControl({ value: dataCustomer.BornDate ? this._globals.getDateFormat(dataCustomer.BornDate) : null, disabled: this.deshabilitarCampos }), //  /Date(1557352800000)/
                notas: new FormControl({ value: dataCustomer.Notes, disabled: this.deshabilitarCampos }),
                arcadCode: new FormControl({ value: dataCustomer.SupplierCustomerRegistry ? dataCustomer.SupplierCustomerRegistry.ArcadCode : null, disabled: this.deshabilitarCampos }), // [Validators.required]
                sfCustomerId: new FormControl({ value: dataCustomer.sfCustomerId ? dataCustomer.sfCustomerId : null, disabled: this.deshabilitarCampos }),

            }),

            contactInformation: new FormGroup({
                telephoneHome: new FormControl({ value: dataCustomer.TelephoneHome, disabled: this.deshabilitarCampos }),
                telephoneOffice: new FormControl({ value: dataCustomer.TelephoneOffice, disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: dataCustomer.TelephonePortable, disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: dataCustomer.Email, disabled: this.deshabilitarCampos }, Validators.pattern(this.emailRegex)),
                fax: new FormControl({ value: dataCustomer.Fax ? dataCustomer.Fax.trim() : '', disabled: this.deshabilitarCampos }),
                privacy: new FormControl({ value: dataCustomer.Privacy, disabled: this.deshabilitarCampos }), // El CLiente autoriza SI NO el tratamiento de sus datos
                customerContactChannelTypeList: new FormControl({ value: dataCustomer.CustomerContactChannelTypeList.length > 0 ? dataCustomer.CustomerContactChannelTypeList : this.CustomerContactChannelTypeList, disabled: this.deshabilitarCampos }),
                dateSignatureConsentDocument: new FormControl({ value: dataCustomer.DateSignatureConsentDocument ? this._globals.getDateFormat(dataCustomer.DateSignatureConsentDocument) : null, disabled: this.deshabilitarCampos }), // Fecha de firma
                customerContactPurposeTypeList: new FormControl({ value: dataCustomer.CustomerContactPurposeTypeList, disabled: this.deshabilitarCampos }),//CA-CC-ES-PE-OT
                thirdAssignment: new FormControl({ value: dataCustomer.ThirdAssignment, disabled: this.deshabilitarCampos }), // Permitir C.Comerciales de la Marca
                allowContactBrand: new FormControl({ value: dataCustomer.AllowContactBrand, disabled: this.deshabilitarCampos }), // Permite cesion de terceros
                allowProfilingBrand: new FormControl({ value: dataCustomer.AllowProfilingBrand, disabled: this.deshabilitarCampos }),// Permite perfilado marca
                consentDocumentId: new FormControl(dataCustomer.ConsentDocumentId),
            }),

            contacts: new FormGroup({
                clientContacts: new FormControl(dataCustomer.ClientContacts ? dataCustomer.ClientContacts : null),
            }),

            gestion: new FormGroup({
                ExemptionVatCode: new FormControl({ value: dataCustomer.ClientCustomerRegistry ? dataCustomer.ClientCustomerRegistry.ExemptionVatCode : '**', disabled: this.deshabilitarCampos }),
                DiscountPR: new FormControl({ value: dataCustomer.CustomerDiscountPR ? dataCustomer.CustomerDiscountPR : { DiscountCode: '**', Description: '**' }, disabled: this.deshabilitarCampos }, [Validators.required]), //DiscountPR
                PriceMO: new FormControl({ value: dataCustomer.PriceMO, disabled: this.deshabilitarCampos }),
                SpecialDiscount: new FormControl({ value: dataCustomer.SpecialDiscount, disabled: this.deshabilitarCampos }),
                DiscountMO: new FormControl({ value: dataCustomer.DiscountMO, disabled: this.deshabilitarCampos }),
                AccountingCode: new FormControl({ value: dataCustomer.AccountingCode, disabled: this.deshabilitarCampos }, [Validators.required]),

                MandateReference: new FormControl({ value: dataCustomer.MandateReference, disabled: this.deshabilitarCampos }),
                MandateSigningDate: new FormControl({ value: dataCustomer.MandateSigningDate ? this._globals.getDateFormat(dataCustomer.MandateSigningDate) : null, disabled: this.deshabilitarCampos }), // Fecha de firma
                CreditLimit: new FormControl({ value: dataCustomer.CreditLimit ? dataCustomer.CreditLimit : 0, disabled: this.deshabilitarCampos }),
                CreditLocked: new FormControl({ value: dataCustomer.CreditLocked ? dataCustomer.CreditLocked : 0, disabled: this.deshabilitarCampos }),
                CreditSpent: new FormControl({ value: dataCustomer.CreditSpent ? dataCustomer.CreditSpent : 0, disabled: this.deshabilitarCampos }),
                PaymentCode: new FormControl({ value: dataCustomer.PaymentCode, disabled: this.deshabilitarCampos }, [paymentCodeValidator()]),
                PaymentDay1: new FormControl({ value: dataCustomer.PaymentDay1, disabled: this.deshabilitarCampos }),
                PaymentDay2: new FormControl({ value: dataCustomer.PaymentDay2, disabled: this.deshabilitarCampos }),
                AmountPendingCashPayments: new FormControl({ value: dataCustomer.AmountPendingCashPayments, disabled: this.deshabilitarCampos }),

                Iban: new FormGroup({
                    AccountType: new FormControl({ value: dataCustomer.Iban.AccountType, disabled: this.deshabilitarCampos }),

                    Country: new FormControl({ value: auxIbanCountry, disabled: this.deshabilitarCampos }),
                    CheckDigit: new FormControl({ value: auxCheckDigit, disabled: this.deshabilitarCampos }),
                    BankCode: new FormControl({ value: auxBankCode, disabled: this.deshabilitarCampos }),
                    BranchCode: new FormControl({ value: auxBranchCode, disabled: this.deshabilitarCampos }),
                    NationalCheckDigit: new FormControl({ value: auxNationalCheckDigit, disabled: this.deshabilitarCampos }),
                    AccountNumber: new FormControl({ value: auxAccountNumber, disabled: this.deshabilitarCampos }),

                    IdentificationNumber: new FormControl({ value: dataCustomer.Iban.IdentificationNumber, disabled: this.deshabilitarCampos }),
                    IsValid: new FormControl(dataCustomer.Iban.IsValid),
                    OwnerAccountType: new FormControl({ value: dataCustomer.Iban.OwnerAccountType, disabled: this.deshabilitarCampos }),
                    Value: new FormControl(dataCustomer.Iban.Value),
                }),
                centres: new FormGroup({
                    AdminCenterEReceptorId: new FormControl(dataCustomer.AdminCenterEReceptorId ? dataCustomer.AdminCenterEReceptorId : 0),
                    AdminCenterEPayerId: new FormControl(dataCustomer.AdminCenterEPayerId ? dataCustomer.AdminCenterEPayerId : 0),
                    AdminCenterEFiscalId: new FormControl(dataCustomer.AdminCenterEFiscalId ? dataCustomer.AdminCenterEFiscalId : 0),
                    AdminCenterEBuyerId: new FormControl(dataCustomer.AdminCenterEBuyerId ? dataCustomer.AdminCenterEBuyerId : 0)
                })

            })
        });
        this.deshabilitandoCampos();
        if (!this.customerFormSubscription) {
            this.customerForm.valueChanges.subscribe((val) => {
                this.saveDataForm(cargarVista);
            });
        }
        this.cambiosDesplegablePais();
        this.saveDataForm(cargarVista);


        this.creadoCustomer.next(true);
    }

    crearFormularioCustomerCargado(cargarVista, dataCustomer) {
        if (dataCustomer.FiscalCode) {
            this.fiscalCodeOrigen = dataCustomer.FiscalCode;
        }
        let auxClientContacts = [];
        const isNew = this._dataSaveService.getCustomerNew(cargarVista).isNew;

        if (isNew) {
            auxClientContacts = [];
        } else {
            if (dataCustomer.contacts && dataCustomer.contacts.clientContacts) {
                auxClientContacts = dataCustomer.contacts.clientContacts;
            }
        }

        this.paisService = this._authService.getDataPais();
        this.comprobarDelete();
        this.comprobarIsDeactivated(dataCustomer);
        this.statusBA = this.testDeleted(dataCustomer.Status);

        if (!this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }


        if (dataCustomer.gestion.Iban.CheckDigit && dataCustomer.gestion.Iban.BankCode && dataCustomer.gestion.Iban.BranchCode && dataCustomer.gestion.Iban.NationalCheckDigit && dataCustomer.gestion.Iban.AccountNumber) {
            this.camposIbanCompletos = true;
            this.isValidIban = dataCustomer.gestion.Iban.IsValid;
        } else {
            this.camposIbanCompletos = false;
        }
        this.CustomerContactChannelTypeList = dataCustomer.contactInformation.CustomerContactChannelTypeList;

        const pais = dataCustomer.datosIdentificacion.pais ? dataCustomer.datosIdentificacion.pais : { CountryCode: 'ES', Name: null };
        this.customerForm = new FormGroup({

            datosPrincipales: new FormGroup({
                CustomerCode: new FormControl({ value: dataCustomer.datosPrincipales.CustomerCode, disabled: true }),
                IdentificationType: new FormControl({ value: dataCustomer.datosPrincipales.IdentificationType ? dataCustomer.datosPrincipales.IdentificationType : '02', disabled: this.deshabilitarCampos }),
                fiscalCode: new FormControl({ value: dataCustomer.datosPrincipales.fiscalCode ? dataCustomer.datosPrincipales.fiscalCode : '', disabled: this.deshabilitarCampos }), //, [Validators.required]
                tratamiento: new FormControl({ value: dataCustomer.datosPrincipales.tratamiento ? dataCustomer.datosPrincipales.tratamiento : 1, disabled: this.deshabilitarCampos }),
                CustomerName: new FormControl({ value: dataCustomer.datosPrincipales.CustomerName ? dataCustomer.datosPrincipales.CustomerName : '', disabled: this.deshabilitarCampos }, [Validators.required]),
                customerSurnameFirst: new FormControl({ value: dataCustomer.datosPrincipales.customerSurnameFirst ? dataCustomer.datosPrincipales.customerSurnameFirst : '', disabled: this.deshabilitarCampos }),
                customerSurnameSecond: new FormControl({ value: dataCustomer.datosPrincipales.customerSurnameSecond ? dataCustomer.datosPrincipales.customerSurnameSecond : '', disabled: this.deshabilitarCampos }),
                customerSelfEmployed: new FormControl({ value: dataCustomer.datosPrincipales.customerSelfEmployed ? dataCustomer.datosPrincipales.customercustomerSelfEmployed : false, disabled: this.deshabilitarCampos }),
                customerBussinesName: new FormControl({ value: dataCustomer.datosPrincipales.customerBussinesName ? dataCustomer.datosPrincipales.customerBussinesName : '', disabled: this.deshabilitarCampos })
            }),

            datosIdentificacion: new FormGroup({
                VATRegime: new FormControl(dataCustomer.VATRegime ? dataCustomer.VATRegime : 'GE'),
                InternalAditionalRole: new FormControl(dataCustomer.datosIdentificacion.InternalAditionalRole ? dataCustomer.datosIdentificacion.InternalAditionalRole.toString() : '0'), // 0 |2 radio button InternalAditionalRole
                customerType: new FormControl(dataCustomer.datosIdentificacion.customerType ? dataCustomer.datosIdentificacion.customerType : '**' , [Validators.required, defaultValueValidator('**')]), //  [C, A, B, S]

                customerCategory: new FormControl({ value: dataCustomer.datosIdentificacion.customerCategory ? dataCustomer.datosIdentificacion.customerCategory : { CUSTOMERCATEGORY: "**", Description: 'No disponible' }, disabled: this.deshabilitarCampos }, [Validators.required]), // Esto es el selector de categoria Cliente
                address: new FormControl({ value: dataCustomer.datosIdentificacion.address ? dataCustomer.datosIdentificacion.address : '', disabled: this.deshabilitarCampos || !this.canUpdateAddress }, [Validators.required]),

                postalCode: new FormControl({ value: dataCustomer.datosIdentificacion.postalCode ? dataCustomer.datosIdentificacion.postalCode : '', disabled: this.deshabilitarCampos || !this.canUpdateAddress }, [postalCodeValidator(this._authService.getDataPais(), pais)]),
                province: new FormControl({ value: dataCustomer.datosIdentificacion.province ? dataCustomer.datosIdentificacion.province : '', disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                city: new FormControl({ value: dataCustomer.datosIdentificacion.city ? dataCustomer.datosIdentificacion.city : '', disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                pais: new FormControl({ value: dataCustomer.datosIdentificacion.pais ? dataCustomer.datosIdentificacion.pais : { CountryCode: 'ES', Name: null }, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                NationalityCode: new FormControl({ value: dataCustomer.datosIdentificacion.NationalityCode ? dataCustomer.datosIdentificacion.NationalityCode : dataCustomer.datosIdentificacion.pais && dataCustomer.datosIdentificacion.pais.CountryCode ? dataCustomer.datosIdentificacion.pais.CountryCode : 'ES' }),
                IntraCommunity: new FormControl({ value: dataCustomer.datosIdentificacion.IntraCommunity === true ? true : false, disabled: this.deshabilitarCampos || !this.canUpdateAddress }),
                fechaNacimiento: new FormControl({ value: dataCustomer.datosIdentificacion.BornDate ? this._globals.getDateFormat(dataCustomer.datosIdentificacion.BornDate) : null, disabled: this.deshabilitarCampos }), //  /Date(1557352800000)/
                notas: new FormControl({ value: dataCustomer.datosIdentificacion.notas ? dataCustomer.datosIdentificacion.notas : '', disabled: this.deshabilitarCampos }),
                arcadCode: new FormControl({ value: dataCustomer.datosIdentificacion.arcadCode ? dataCustomer.datosIdentificacion.arcadCode.ArcadCode : '', disabled: this.deshabilitarCampos }), // [Validators.required]
                sfCustomerId: new FormControl({ value: dataCustomer.datosIdentificacion.sfCustomerId ? dataCustomer.datosIdentificacion.sfCustomerId : '', disabled: this.deshabilitarCampos }),

            }),

            contactInformation: new FormGroup({
                telephoneHome: new FormControl({ value: dataCustomer.contactInformation.telephoneHome ? dataCustomer.contactInformation.telephoneHome : '', disabled: this.deshabilitarCampos }),
                telephoneOffice: new FormControl({ value: dataCustomer.contactInformation.telephoneOffice ? dataCustomer.contactInformation.telephoneOffice : '', disabled: this.deshabilitarCampos }),
                telephonePortable: new FormControl({ value: dataCustomer.contactInformation.telephonePortable ? dataCustomer.contactInformation.telephonePortable : '', disabled: this.deshabilitarCampos }),
                email: new FormControl({ value: dataCustomer.contactInformation.email ? dataCustomer.contactInformation.email : '', disabled: this.deshabilitarCampos }),
                fax: new FormControl({ value: dataCustomer.contactInformation.fax ? dataCustomer.contactInformation.fax.trim() : '', disabled: this.deshabilitarCampos }),
                privacy: new FormControl({ value: dataCustomer.contactInformation.privacy ? dataCustomer.contactInformation.privacy : 'N', disabled: this.deshabilitarCampos }), // El CLiente autoriza SI NO el tratamiento de sus datos
                customerContactChannelTypeList: new FormControl({ value: dataCustomer.contactInformation.customerContactChannelTypeList, disabled: this.deshabilitarCampos }),
                dateSignatureConsentDocument: new FormControl({ value: dataCustomer.contactInformation.dateSignatureConsentDocument ? this._globals.getDateFormat(dataCustomer.contactInformation.DateSignatureConsentDocument) : null, disabled: this.deshabilitarCampos }), // Fecha de firma
                customerContactPurposeTypeList: new FormControl({ value: dataCustomer.contactInformation.customerContactPurposeTypeList, disabled: this.deshabilitarCampos }),//CA-CC-ES-PE-OT
                thirdAssignment: new FormControl({ value: dataCustomer.contactInformation.thirdAssignment ? dataCustomer.contactInformation.thirdAssignment : true, disabled: this.deshabilitarCampos }), // Permitir C.Comerciales de la Marca
                allowContactBrand: new FormControl({ value: dataCustomer.contactInformation.allowContactBrand ? dataCustomer.contactInformation.allowContactBrand : false, disabled: this.deshabilitarCampos }), // Permite cesion de terceros
                allowProfilingBrand: new FormControl({ value: dataCustomer.contactInformation.allowProfilingBrand ? dataCustomer.contactInformation.allowProfilingBrand : false, disabled: this.deshabilitarCampos }),// Permite perfilado marca
                consentDocumentId: new FormControl(dataCustomer.contactInformation.consentDocumentId)
            }),

            contacts: new FormGroup({
                clientContacts: new FormControl(auxClientContacts),
            }),

            gestion: new FormGroup({
                ExemptionVatCode: new FormControl({ value: dataCustomer.gestion.ExemptionVatCode ? dataCustomer.gestion.ExemptionVatCode : '**', disabled: this.deshabilitarCampos }),
                DiscountPR: new FormControl({ value: dataCustomer.gestion.DiscountPR ? dataCustomer.gestion.DiscountPR : { DiscountCode: '**', Description: '**' }, disabled: this.deshabilitarCampos }, [Validators.required]), //DiscountPR
                PriceMO: new FormControl({ value: dataCustomer.gestion.PriceMO ? dataCustomer.gestion.PriceMO : 0, disabled: this.deshabilitarCampos }),
                SpecialDiscount: new FormControl({ value: dataCustomer.gestion.SpecialDiscount ? dataCustomer.gestion.SpecialDiscount : 0, disabled: this.deshabilitarCampos }),
                DiscountMO: new FormControl({ value: dataCustomer.gestion.DiscountMO ? dataCustomer.gestion.DiscountMO : '**', disabled: this.deshabilitarCampos }),
                AccountingCode: new FormControl({ value: dataCustomer.gestion.AccountingCode ? dataCustomer.gestion.AccountingCode : '', disabled: this.deshabilitarCampos }, [Validators.required]),

                MandateReference: new FormControl({ value: dataCustomer.gestion.MandateReference ? dataCustomer.gestion.MandateReference : null, disabled: this.deshabilitarCampos }),
                MandateSigningDate: new FormControl({ value: dataCustomer.gestion.MandateSigningDate ? dataCustomer.gestion.MandateSigningDate : null, disabled: this.deshabilitarCampos }), // Fecha de firma
                CreditLimit: new FormControl({ value: dataCustomer.gestion.CreditLimit ? dataCustomer.gestion.CreditLimit : 0, disabled: this.deshabilitarCampos }),
                CreditLocked: new FormControl({ value: dataCustomer.gestion.CreditLocked ? dataCustomer.gestion.CreditLocked : false, disabled: this.deshabilitarCampos }),
                CreditSpent: new FormControl({ value: dataCustomer.gestion.CreditSpent ? dataCustomer.gestion.CreditSpent : 0, disabled: this.deshabilitarCampos }),
                PaymentCode: new FormControl({ value: dataCustomer.gestion.PaymentCode ? dataCustomer.gestion.PaymentCode : '***', disabled: this.deshabilitarCampos }, [paymentCodeValidator()]),
                PaymentDay1: new FormControl({ value: dataCustomer.gestion.PaymentDay1 ? dataCustomer.gestion.PaymentDay1 : null, disabled: this.deshabilitarCampos }),
                PaymentDay2: new FormControl({ value: dataCustomer.gestion.PaymentDay2 ? dataCustomer.gestion.PaymentDay2 : null, disabled: this.deshabilitarCampos }),
                AmountPendingCashPayments: new FormControl({ value: dataCustomer.gestion.AmountPendingCashPayments ? dataCustomer.gestion.AmountPendingCashPayments : 0, disabled: this.deshabilitarCampos }),

                Iban: new FormGroup({
                    AccountNumber: new FormControl({ value: dataCustomer.gestion.Iban.AccountNumber ? dataCustomer.gestion.Iban.AccountNumber : '', disabled: this.deshabilitarCampos }),
                    AccountType: new FormControl({ value: dataCustomer.gestion.Iban.AccountType ? dataCustomer.gestion.Iban.AccountType : '', disabled: this.deshabilitarCampos }),
                    BankCode: new FormControl({ value: dataCustomer.gestion.Iban.BankCode ? dataCustomer.gestion.Iban.BankCode : '', disabled: this.deshabilitarCampos }),
                    BranchCode: new FormControl({ value: dataCustomer.gestion.Iban.BranchCode ? dataCustomer.gestion.Iban.BranchCode : '', disabled: this.deshabilitarCampos }),
                    CheckDigit: new FormControl({ value: dataCustomer.gestion.Iban.CheckDigit, disabled: this.deshabilitarCampos }),
                    Country: new FormControl({ value: dataCustomer.gestion.Iban.Country ? dataCustomer.gestion.Iban.Country : 'ES', disabled: this.deshabilitarCampos }),
                    IdentificationNumber: new FormControl({ value: dataCustomer.gestion.Iban.IdentificationNumber ? dataCustomer.gestion.Iban.IdentificationNumber : '', disabled: this.deshabilitarCampos }),
                    IsValid: new FormControl(dataCustomer.gestion.Iban.IsValid ? dataCustomer.gestion.Iban.IsValid : false),
                    NationalCheckDigit: new FormControl({ value: dataCustomer.gestion.Iban.NationalCheckDigit ? dataCustomer.gestion.Iban.NationalCheckDigit : '', disabled: this.deshabilitarCampos }),
                    OwnerAccountType: new FormControl({ value: dataCustomer.gestion.Iban.OwnerAccountType ? dataCustomer.gestion.Iban.OwnerAccountType : '', disabled: this.deshabilitarCampos }),
                    Value: new FormControl(dataCustomer.gestion.Iban.Value ? dataCustomer.gestion.Iban.Value : ''),
                }),
                centres: new FormGroup({
                    AdminCenterEReceptorId: new FormControl(dataCustomer.AdminCenterEReceptorId ? dataCustomer.AdminCenterEReceptorId : 0),
                    AdminCenterEPayerId: new FormControl(dataCustomer.AdminCenterEPayerId ? dataCustomer.AdminCenterEPayerId : 0),
                    AdminCenterEFiscalId: new FormControl(dataCustomer.AdminCenterEFiscalId ? dataCustomer.AdminCenterEFiscalId : 0),
                    AdminCenterEBuyerId: new FormControl(dataCustomer.AdminCenterEBuyerId ? dataCustomer.AdminCenterEBuyerId : 0)
                })

            })
        });
        this.deshabilitandoCampos();
        this.customerForm.get('gestion').get('SpecialDiscount').valueChanges.subscribe(val => {
            if (val !== '') {
                const auxVal = this.setTwoNumberDecimal(val);
            };
        });

        // this.customerForm.get('datosPrincipales').get('fiscalCode').valueChanges.subscribe(val => {
        //     //solo en caso de españa y portugal
        //     if (val !== '') {
        //         const b = {
        //             fiscalCode: val
        //         };
        //         switch (this.paisService) {
        //             case 'es':
        //                 this.validacionFiscalCode(b);
        //                 break;
        //             case 'fr':
        //                 // no se valida
        //                 break;
        //             case 'pt':
        //                 this.validacionFiscalCode(b);
        //                 break;
        //         }
        //     }
        // });

        if (!this.customerFormSubscription) {
            this.customerForm.valueChanges.subscribe((val) => {
                this.saveDataForm(cargarVista);
            });
        }
        this.cambiosDesplegablePais();
        this.saveDataForm(cargarVista);

    }

    setTwoNumberDecimal(dato) {
        return parseFloat(dato).toFixed(2);
    }

    deshabilitandoCampos() {
        if (!this.modoEdicion) {
            this.customerForm.get('datosIdentificacion').get('InternalAditionalRole').disable();
            this.customerForm.get('datosIdentificacion').get('customerType').disable();
        } else {
            /***************/
            if (this.pantalla === 'voClientes') {
                this.customerForm.get('datosIdentificacion').get('InternalAditionalRole').disable();
                this.customerForm.get('datosIdentificacion').get('customerType').disable();
            } else {
                this.customerForm.get('datosIdentificacion').get('InternalAditionalRole').enable();
                this.customerForm.get('datosIdentificacion').get('customerType').enable();
            }
        }
    }

    // Esta validacion es para el guardado del formulario . A dia 2-4-2020 se me pide que cambie a permitir guardar
    validacionFiscalCode(b) {
        // b.fiscalCode = b.fiscalCode ? b.fiscalCode : '';
        this._validateFiscalCodeService.post<any>(JSON.stringify(b)).subscribe(resp => {
            const auxData = resp.Response;
            if (auxData.IsValid) {
                this.isValidEntryFiscalCode = true;

                this.customerForm.controls.datosPrincipales.get('fiscalCode').setValue(b.fiscalCode + auxData.letter);
            } else {
                // No es valida
                this.isValidEntryFiscalCode = false;
            }
        });

        // Comprobamos si esta duplicado independientemente de que sea invalido
        if (this.newCustomer) {
            this.fiscalCodeOrigen = '';
            this.estaDuplicadoCodigoFiscal(b);
        } else {
            const fiscalCodeOrigen = this.fiscalCodeOrigen ? this.fiscalCodeOrigen.toUpperCase().trim() : '';
            // Si el cod fiscal es igual al que ya habia le marcamos como no duplicado
            if (fiscalCodeOrigen !== b.fiscalCode.trim()) {
                this.estaDuplicadoCodigoFiscal(b);
            } else {
                this.isDuplicateFiscalCode = false;
                this.customerForm.controls.datosPrincipales.get('fiscalCode').setErrors({ 'invalidFiscalCode': null });
                this.customerForm.controls.datosPrincipales.get('fiscalCode').updateValueAndValidity({ emitEvent: false });
            }
        }

    }

    estaDuplicadoCodigoFiscal(codigoFiscal) {
        this.isDuplicateFiscalCode = false;
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/ExistsByFiscalCode`;
        const param = {
            searchValue: codigoFiscal.fiscalCode.trim()
        };

        this._generalGestionTercerosService.existsByFiscalCode(_URL_, param).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.isDuplicateFiscalCode = auxdata.Data;
                if (this.isDuplicateFiscalCode) {
                    this.customerForm.controls.datosPrincipales.get('fiscalCode').setErrors({ 'invalidFiscalCode': true });
                } else {

                    this.customerForm.controls.datosPrincipales.get('fiscalCode').setErrors({ 'invalidFiscalCode': null });
                    this.customerForm.controls.datosPrincipales.get('fiscalCode').updateValueAndValidity({ emitEvent: false });

                }

            }
        });

    }

    observerMoveOn() {
        return this.moveOn.asObservable();
    }
    observerMoveIn() {
        return this.moveIn.asObservable();
    }

    observerCreadoCustomer() {
        return this.creadoCustomer.asObservable();
    }


    observerAllDataCustomer() {
        return this.allDataCustomer.asObservable();
    }

    setAllDataCustomer(value) {
        this._datosCustomer = value;
        this.allDataCustomer.next(value);
    }


    getDatosCustomerGestionForm() {
        return this.datosCustomerGestionForm;
    }

    setDatosCustomerGestionForm(value) {
        this.datosCustomerGestionForm = value;
    }

    //Gestion Terceros servicio getByCustomerCodeWithContacts
    getByCustomerCodeWithContactsSave() {
        return this.dataCustomerSave;
    }
    setByCustomerCodeWithContactsSave(value) {
        this.dataCustomerSave = value;
    }

    set currentStep(value) {
        this._currentStep = value;
    }
    get currentStep() {
        return this._currentStep;
    }

    getPantalla() {
        return this.pantalla;
    }

    setPantalla(value) {
        this.pantalla = value;
    }
    getModoEdicion() {
        return this.modoEdicion;
    }

    setModoEdicion(value) {
        this.modoEdicion = value;
    }


    getEscogidoBuscador() {
        return this.escogidoBuscador;
    }
    setEscogidoBuscador(value) {
        this.escogidoBuscador = value;
    }


    getBusquedaPor() {

        return this.busquedaPor;
    }
    setBusquedaPor(value) {
        // 0 por Input
        // 1 por Botonera
        this.busquedaPor = value;
    }




    observerActualCustomerCode() {
        return this.actualCustomerCode.asObservable();
    }
    setCustomer(value) {
        this.auxCustomerCode = value;
        this.actualCustomerCode.next(value);
    }



    setMoveDer(value) {
        this.moveOn.next(value);
    }

    setMoveIzq(value) {
        this.moveIn.next(value);
    }

    openNewCustomer(cargarVista, valor) {
        this.newCustomer = valor;
        const auxNew = {
            'isNew': valor
        };
        this._dataSaveService.setCustomerNew(cargarVista, auxNew);

        this.sePuedeDesactivar = false;
        this.botonReactivar = false;
        this.botonGuardar = true;

        this.siguiente(cargarVista);
    }
    anterior(cargarVista) {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
        if (this.currentStep === 0) {
            this.reset(cargarVista);
        }
        const auxSteep = {
            'step': this.currentStep
        };
        this._buttonsActivateService.actualizarBtnAdjunto(false);

        this._dataSaveService.setStepsView(cargarVista, auxSteep);
    }

    siguiente(cargarVista) {
        this.currentStep++;
        const auxSteep = {
            'step': this.currentStep
        };
        this._dataSaveService.setStepsView(cargarVista, auxSteep);
    }

    reset(cargarVista) {
        this.newCustomer = false;
        const auxNew = {
            'isNew': false
        };
        this._dataSaveService.setCustomerNew(cargarVista, auxNew);
        this.customerForm = undefined;
        //vacio el dataService
        this._dataSaveService.setFormulario(cargarVista, { 'form': null });
        this._dataSaveService.setStepsView(cargarVista, { 'step': 0 });
        this._dataSaveService.setTabsView(cargarVista, { 'tab': 0 });
        this._dataSaveService.setDatosRowTabla(cargarVista, {});
        this.objetoPaginacion = {
            'skip': 0,
            'pageNumber': 1,
            'pageSize': 20
        };
        this._dataSaveService.setDatosPaginacion(cargarVista, this.objetoPaginacion);
    }

    comprobarDelete() {
        const parametros_In = {
            customerID: this.auxCustomerCode
        };

        this._canBeDeleteService.post<any>(JSON.stringify(parametros_In)).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.puedeBorrarse = auxdata.Data
            }
        });
    }

    comprobarIsDeactivated(dataCustomer) {
        this.revocaDate = null;
        const parametros_In = {
            customerID: this.auxCustomerCode
        }
        this._isDeactivatedService.post<any>(JSON.stringify(parametros_In)).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.estaDesactivado = auxdata.Data;
                if (this.estaDesactivado) {
                    this.sePuedeDesactivar = false;
                    this.botonReactivar = true;
                    this.botonGuardar = false;
                    if (dataCustomer.ClientCustomerRegistry && dataCustomer.ClientCustomerRegistry.RevocaDate) {
                        this.revocaDate = this._globals.getDateFormatMDY(dataCustomer.ClientCustomerRegistry.RevocaDate);
                    }
                } else {
                    this.sePuedeDesactivar = true;
                    this.botonReactivar = false;
                    this.botonGuardar = true;
                    this.revocaDate = null;
                }

            }
        });
    }

    rsdAdminRole(): boolean {
        return this._authService.getUserRoleRspAdmin() === '07';
    }

    testDeleted(status: string): boolean {
        return status === 'BA';
    }

    checkEsa() {
        return this._http.post(`${environment.ENTORNO}Services/Workshop/EsaService.svc/GetAvailability`, {})
            .pipe(map((data) => data["Response"]));
    }

    checkSelfEmployed() {
        const tratamiento = this.customerForm.get('datosPrincipales').get('tratamiento').value;
        const customerSelfEmployed = this.customerForm.get('datosPrincipales').get('customerSelfEmployed').value;

        if(tratamiento === 1 || tratamiento === 2 || tratamiento === 3) {
            if(customerSelfEmployed === true){
                this.customerForm.controls.datosPrincipales.get('customerBussinesName').enable({onlySelf:true, emitEvent:false});
                this.customerForm.get('datosPrincipales').get('customerBussinesName').setValidators([Validators.required]);
            }else{
                this.customerForm.controls.datosPrincipales.get('customerBussinesName').clearValidators();
                this.customerForm.controls.datosPrincipales.get('customerBussinesName').setValue('', { emitEvent: false });
                this.customerForm.controls.datosPrincipales.get('customerBussinesName').disable({onlySelf:true, emitEvent:false});
            }
        } else {
            this.customerForm.controls.datosPrincipales.get('customerBussinesName').clearValidators();
            this.customerForm.controls.datosPrincipales.get('customerBussinesName').setValue('', { emitEvent: false });
            this.customerForm.controls.datosPrincipales.get('customerSelfEmployed').setValue(false, { emitEvent: false });
            this.customerForm.controls.datosPrincipales.get('customerBussinesName').disable({onlySelf:true, emitEvent:false});
        }
    }

    customerReactivated(params) {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.Reactivate}`;
        return this._http.post<any>(url, params);
    }

    getUniqueSearchCode() {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.GetUniqueSearchCode}`;
        return this._http.post<any>(url, null);
    }

    customerCanBeDeactivated(params) {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.CanBeDeactivated}`;
        return this._http.post<any>(url, params);
    }

    searchCodeUnique(params) {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.GetBySearchCode}`;
        return this._http.post<any>(url, params);
    }

    customerUpdate(params) {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.Update}`;
        return this._http.post<any>(url, params);
    }

    validateIbanCode(params) {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.ValidateIban}`;
        return this._http.post<any>(url, params).pipe(map(resp => {
            return resp.contents;
        }));
    }
}


